import { AGENT_PERSONAS, type AgentId } from "./agents";

// ── Resolve Agent from Workflow ID ───────────────────────────────────────────

export function resolveAgentId(workflowSlug: string): AgentId | null {
  for (const [agentId, persona] of Object.entries(AGENT_PERSONAS)) {
    if (persona.workflowSlugs.includes(workflowSlug)) {
      return agentId as AgentId;
    }
  }
  // full-package → operator
  if (workflowSlug === "full-package") return "operator";
  return null;
}
